<template>
	<div class="footer">
		<div class="footer-logo">
			<div class="footer-logo-image">
				<img :src="config.footer_company">
			</div>
			<div class="footer-logo-info">
				<div class="footer-title">
					{{config.company_name}}
				</div>
				<div class="footer-add">
					电话：{{config.tel}}
				</div>
				<div class="footer-tel">
					邮箱：{{config.email}}
				</div>
				<div class="footer-tel">
					地址：{{config.address}}
				</div>
			</div>

			<div class="footer-qr">
				<img :src="config.site_qr">
				<img :src="config.contact_qr">
			</div>
		</div>

		<div class="footer-copy">
			<div class="footer-copy-no">
				<a href="http://beian.miit.gov.cn/" target="_blank">{{config.icp}}</a>
			</div>
			<div class="footer-copy-info">
				{{config.copy}}
			</div>
		</div>
	
	</div>
</template>

<script>
	import {common_nav,common_config} from '@/api/common.js';
	export default {
		name: 'commonFooter',
		data() {
			return {
				data:[],
				config:{},
			}
		},
		created() {
			this.get_data();
			this.get_config();
		},
		methods: {
			get_data(){
				common_nav({nav_id:2}).then(res=>{
					if(res.code==1){
						this.data = res.data;
					}
				});
			},

			get_config(){
				common_config({}).then(res=>{
					if(res.code==1){
						this.config = res.data;
					}
				});
			},

			url(path){
				if(path.indexOf("http") != -1){
					window.location.href = path;
				}else{
					this.$router.push(path);
				}
			},
		}
	}
</script>
<style scoped>

	.footer {
		background: #3d3d3d;
		color: #fff;
	}

	.footer-logo {
		width: calc(100% - 30px);
		margin: 15px;
		position: relative;
		padding-top: 20px;
	}

	.footer-logo-image img {
		width: 160px;
	}
	.footer-logo-info {
		margin-top: 10px;
	}

	.footer-logo-info .footer-title {
		font-size: 16px;
		font-weight: 700;
	}


	.footer-logo-info .footer-add {
		margin-top: 10px;
		font-size: 12px;
		font-weight: 300;
	}

	.footer-logo-info .footer-tel {
		margin-top: 10px;
		font-size: 12px;
		font-weight: 300;
	}

	.footer-qr{
		position: absolute;
		right: 0;
		top: 20px;
		width: 100px;
		text-align: right;
	}

	.footer-qr img{
		width: 60px;
		margin-bottom: 10px;
	}
	.footer-copy {
		text-align: center;	
		height: 60px;
		width: 100%;
		color: #666;
		font-size: 12px;
	}
	.footer-copy-no{
		margin-bottom: 3px;
	}
	.footer-copy-no a {
		color: #666;
		text-decoration: none;
	}
	.footer-copy-no a:hover{
		color: #888;
	}
	
</style>
